export default __webpack_public_path__ + "static/media/noavatar1.69967dcc.png";